<template>
  <div
    v-show="isShow"
    class="mask-layer"
    :style="{ backgroundColor: maskBg }"
    @mousedown="mousedown($event)"
  >
    <cutter-progress
      v-if="info"
      :info="info"
      :type="type"
      @cancel="cancel"
    ></cutter-progress>
    <eyedropper
      v-if="type === 'eyedropper'"
      :msg="msg"
      @cancel="cancel"
    ></eyedropper>
  </div>
</template>
<script>
export default {
  components: {
    CutterProgress: () => import('@/components/mask/cutterProgress.vue'),
    Eyedropper: () => import('@/components/mask/eyedropper.vue')
  },
  data() {
    return {
      isShow: false,
      type: '',
      info: null,
      msg: null,
      maskBg: 'rgba(0, 0, 0, .8)'
    };
  },
  watch: {
    '$route.path': function() {
      if (this.isShow) {
        this.cancel();
      }
    }
  },
  mounted() {
    this.$bus.on('maskLayer', this.maskShow);
  },
  methods: {
    maskShow(data) {
      if (data.show) {
        this.isShow = true;
        this.type = data.type;
        this.info = data.info || null;
        this.msg = data.msg || null;
        data.maskBg && (this.maskBg = data.maskBg);
      } else {
        this.cancel();
      }
    },
    cancel() {
      this.isShow = false;
      this.type = '';
      this.info = null;
      this.msg = null;
      this.maskBg = 'rgba(0, 0, 0, .8)';
    },
    mousedown(e) {
      if (this.type === 'eyedropper') {
        e.stopPropagation();
        this.cancel();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.mask-layer {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
}
</style>
